import React from 'react'
import PropTypes from 'prop-types'
import error from '../assets/img/Hint__error.svg'
import Tooltip from '@material-ui/core/Tooltip';


class Hint extends React.Component {
  render () {
    return(
      <a href='//help.cocorobo.hk/#/cocomod/coco-cloud?id=%E5%89%B5%E5%BB%BA%E4%BA%8B%E4%BB%B6%E5%B1%AC%E6%80%A7' target='_blank' >
        {/*<Tooltip title={this.props.tooltip} aria-label="Add">*/}
          <img className='Hint' src={error} width='20px' height='20px'/>
        {/*</Tooltip>*/}
      </a>
    )
  }
}

export default Hint;



// WEBPACK FOOTER //
// ./src/components/Hint.js